// extracted by mini-css-extract-plugin
export default {"root":"overlay_root__x-pIz","root_visible":"overlay_root_visible__haN1O","stripes-animation-background-keyframes":"overlay_stripes-animation-background-keyframes__BSTC0"};